import run from '../../utilities/run';
import attachBulkUploadDataTable from './bulkUploadDataTable';
import attachBulkUploadDeailview from './bulkUploadDetailView';
import bulkUploadCsvFiles from "./bulkLoadUpload.js";
import "./bulkUploadDetails.js";

//const targetSelector = "#p_p_id_channels_WAR_hcportlet_";
 const bulkUploadRecordsTargetSelector = ".bulk-upload-datatable-container";
 const bulkUploadDetailViewTargetSelector = ".bulk-upload-deail-view-container";
 const bulkUploadCsvFilesTargetSelector = ".bulk-upload-csv-files-container";

 // to render bulk upload records
run(bulkUploadRecordsTargetSelector, ()=>{
  attachBulkUploadDataTable(bulkUploadRecordsTargetSelector);
});


// to render bulk upload record details
run(bulkUploadDetailViewTargetSelector, ()=>{
  attachBulkUploadDeailview(bulkUploadDetailViewTargetSelector);
});

//to render bulk upload csv page
run(bulkUploadCsvFilesTargetSelector, ()=>{
  bulkUploadCsvFiles(bulkUploadCsvFilesTargetSelector);
});



// WEBPACK FOOTER //
// ./src/pages/bulkUpload/index.js